import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router';

import { useAppDispatch, useAppSelector } from '@app/hooks';
import { BaseSpinner } from '@shared/components/base';
import { onSignedOutElsewhere } from '@shared/session/authChannel';
import { selectSessionStatus, signedOut } from '@shared/session/sessionSlice';

import { useRefreshSessionMutation } from '../api/authApi';
import { AUTH_TEXT } from '../constants';

/**
 * Root of the route tree. On first load it restores the session from the refresh cookie
 * (plan §9.1 "Session restore"), shows a spinner meanwhile, and listens for sign-outs
 * in other tabs.
 */
export function SessionGate() {
  const status = useAppSelector(selectSessionStatus);
  const dispatch = useAppDispatch();
  const [refresh] = useRefreshSessionMutation();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void refresh(undefined);
  }, [refresh]);

  useEffect(
    () =>
      // A broadcast sign-out always comes from someone pressing "Sign out" (this tab's own
      // listener hears it too), so record it as a user sign-out everywhere.
      onSignedOutElsewhere(() => {
        dispatch(signedOut('user'));
      }),
    [dispatch],
  );

  if (status === 'checking') {
    return (
      <div className="grid min-h-screen place-items-center">
        <BaseSpinner label={AUTH_TEXT.checkingSession} />
      </div>
    );
  }
  return <Outlet />;
}
